import type { Step } from '../types/step';
import { getAddMaintenanceReminderSteps } from '../common/addmaintenance';
import { StepCategory } from '../../types/app_data';

/**
 * Steps for adding maintenance reminders after garage cross-sell
 */
export const AddMaintenanceReminderAfterGarageSteps: Step[] = getAddMaintenanceReminderSteps({
  flowCategory: StepCategory.Other,

  flowFilter: (appData) => {
    // skip if garage service is selected
    // it should have been asked in previous steps
    if (appData.serviceSplitSelectedService?.garage) {
      return false;
    }
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    // show if user has accepted garage service in garage cross-sell step
    return !!appData.selectedService?.garage;
  },

  skipFirstPromptStep: () => true,
});
